import { render } from "./Impu.vue?vue&type=template&id=9873dff6"
import script from "./Impu.vue?vue&type=script&lang=js"
export * from "./Impu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__